import { useParams } from 'react-router-dom'
import { api } from '@/api/client'
import { useAsync } from '@/components/useAsync'
import { TaskFlow } from '@/components/reviews/TaskFlow'
import type { TaskDetail } from '@/lib/types'

export default function EngTaskReview() {
  const { taskId = '' } = useParams()
  const { data, setData, error, loading } = useAsync(() => api.get<TaskDetail>(`/tasks/${taskId}`), [taskId])
  if (loading) return <p className="muted">Loading…</p>
  if (error || !data) return <div className="note err">{error}</div>
  return <TaskFlow data={data} role="engineer" onSaved={setData} />
}
